<template>
  <div>
    <!---->
    <b-row>
      <b-col md="5" offset-md="3">
        <b-card no-body class="border mb-1">
          <b-card-body class="p-2 m-0 ">
            <b-card-title class="p-1 m-0 text-center ">
              {{ $t("roadmap.stage.platform-stages-completed") }}
            </b-card-title>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!---->
    <b-row>
      <b-col md="1" offset-md="5" class="text-center"> <i class="bx bx-down-arrow-alt font-size-24 text-muted"></i> </b-col>
    </b-row>
    <!---->
    <b-row>
      <b-col md="7" offset-md="2">
        <b-card no-body class="border mb-1" :class="isOrganizationContextStageEdited ? 'border-warning' : ''">
          <b-card-title class="p-1 m-0 mt-2 text-center ">{{ $t("roadmap.stage.bgys-organization-context") }}</b-card-title>

          <content-loading v-if="isOrganizationContextLoading" />
          <b-card-body v-else class="p-2 m-0 ">
            <textarea class="form-control" placeholder="Aşama Açıklaması" v-model="descriptionOrganizationContext"> </textarea>
            <h5>{{ $t("task.plural") }}</h5>
            <div v-for="task in tasksOrganizationContext" :key="task._id" class="card card-body">
              <sweet-button :only-icon="true" variant="false" icon="mdi mdi-delete" buttonClass="text-danger hidden float-right" @click="removeTaskItem(task)" />
              <sweet-button :only-icon="true" variant="false" icon="mdi mdi-pencil" buttonClass="text-warning hidden float-right" @click="editTaskItem(task)" />

              <h6>{{ $t("task.name") }}</h6>
              {{ task.name | translate }}
              <h6>{{ $t("task.description") }}</h6>
              {{ task.description | translate }}

              <div v-if="task.blockedByTasks && task.blockedByTasks.length > 0">
                <h6>{{ $t("task.blocked-by") }}</h6>
                <ol>
                  <li v-for="t in task.blockedByTasks" :key="t._id">{{ t.name | translate }}</li>
                </ol>
              </div>
            </div>

            <roadmap-stage-task-form store="managementBgysRoadmap" stage="BGYS_ORGANIZATION_CONTEXT" />
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!---->
    <b-row>
      <b-col md="1" offset-md="5" class="text-center"> <i class="bx bx-down-arrow-alt font-size-24 text-muted"></i> </b-col>
    </b-row>
    <!---->
    <b-row>
      <b-col md="7" offset-md="2">
        <b-card no-body class="border mb-1" :class="isLeadershipStageEdited ? 'border-warning' : ''">
          <b-card-title class="p-1 m-0 mt-2 text-center ">{{ $t("roadmap.stage.bgys-leadership") }}</b-card-title>

          <content-loading v-if="isLeadershipLoading" />
          <b-card-body v-else class="p-2 m-0 ">
            <textarea class="form-control" placeholder="Aşama Açıklaması" v-model="descriptionLeadership"> </textarea>
            <h5>{{ $t("task.plural") }}</h5>
            <div v-for="task in tasksLeadership" :key="task._id" class="card card-body">
              <sweet-button :only-icon="true" variant="false" icon="mdi mdi-delete" buttonClass="text-danger hidden float-right" @click="removeTaskItem(task)" />
              <sweet-button :only-icon="true" variant="false" icon="mdi mdi-pencil" buttonClass="text-warning hidden float-right" @click="editTaskItem(task)" />

              <h6>{{ $t("task.name") }}</h6>
              {{ task.name | translate }}
              <h6>{{ $t("task.description") }}</h6>
              {{ task.description | translate }}

              <div v-if="task.blockedByTasks && task.blockedByTasks.length > 0">
                <h6>{{ $t("task.blocked-by") }}</h6>
                <ol>
                  <li v-for="t in task.blockedByTasks" :key="t._id">{{ t.name | translate }}</li>
                </ol>
              </div>
            </div>

            <roadmap-stage-task-form store="managementBgysRoadmap" stage="BGYS_LEADERSHIP" />
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!---->
    <b-row>
      <b-col md="1" offset-md="5" class="text-center"> <i class="bx bx-down-arrow-alt font-size-24 text-muted"></i> </b-col>
    </b-row>
    <!---->
    <b-row>
      <b-col md="7" offset-md="2">
        <b-card no-body class="border mb-1" :class="isPlanningStageEdited ? 'border-warning' : ''">
          <b-card-title class="p-1 m-0 mt-2 text-center ">{{ $t("roadmap.stage.bgys-planning") }}</b-card-title>

          <content-loading v-if="isPlanningLoading" />
          <b-card-body v-else class="p-2 m-0 ">
            <textarea class="form-control" placeholder="Aşama Açıklaması" v-model="descriptionPlanning"> </textarea>
            <h5>{{ $t("task.plural") }}</h5>
            <div v-for="task in tasksSupport" :key="task._id" class="card card-body">
              <sweet-button :only-icon="true" variant="false" icon="mdi mdi-delete" buttonClass="text-danger hidden float-right" @click="removeTaskItem(task)" />
              <sweet-button :only-icon="true" variant="false" icon="mdi mdi-pencil" buttonClass="text-warning hidden float-right" @click="editTaskItem(task)" />

              <h6>{{ $t("task.name") }}</h6>
              {{ task.name | translate }}
              <h6>{{ $t("task.description") }}</h6>
              {{ task.description | translate }}

              <div v-if="task.blockedByTasks && task.blockedByTasks.length > 0">
                <h6>{{ $t("task.blocked-by") }}</h6>
                <ol>
                  <li v-for="t in task.blockedByTasks" :key="t._id">{{ t.name | translate }}</li>
                </ol>
              </div>
            </div>

            <roadmap-stage-task-form store="managementBgysRoadmap" stage="BGYS_PLANNING" />
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="1" offset-md="5" class="text-center"> <i class="bx bx-down-arrow-alt font-size-24 text-muted"></i> </b-col>
    </b-row>

    <b-row>
      <b-col md="7" offset-md="2">
        <b-card no-body class="border mb-1" :class="isSupportStageEdited ? 'border-warning' : ''">
          <b-card-title class="p-1 m-0 mt-2 text-center ">{{ $t("roadmap.stage.bgys-support") }}</b-card-title>

          <content-loading v-if="isSupportLoading" />
          <b-card-body v-else class="p-2 m-0 ">
            <textarea class="form-control" placeholder="Aşama Açıklaması" v-model="descriptionSupport"> </textarea>
            <h5>{{ $t("task.plural") }}</h5>
            <div v-for="task in tasksPlanning" :key="task._id" class="card card-body">
              <sweet-button :only-icon="true" variant="false" icon="mdi mdi-delete" buttonClass="text-danger hidden float-right" @click="removeTaskItem(task)" />
              <sweet-button :only-icon="true" variant="false" icon="mdi mdi-pencil" buttonClass="text-warning hidden float-right" @click="editTaskItem(task)" />

              <h6>{{ $t("task.name") }}</h6>
              {{ task.name | translate }}
              <h6>{{ $t("task.description") }}</h6>
              {{ task.description | translate }}

              <div v-if="task.blockedByTasks && task.blockedByTasks.length > 0">
                <h6>{{ $t("task.blocked-by") }}</h6>
                <ol>
                  <li v-for="t in task.blockedByTasks" :key="t._id">{{ t.name | translate }}</li>
                </ol>
              </div>
            </div>

            <roadmap-stage-task-form store="managementBgysRoadmap" stage="BGYS_SUPPORT" />
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!---->
    <b-row>
      <b-col md="1" offset-md="5" class="text-center"> <i class="bx bx-down-arrow-alt font-size-24 text-muted"></i> </b-col>
    </b-row>
    <!---->

    <!---->
    <b-row>
      <b-col md="7" offset-md="2">
        <b-card no-body class="border mb-1" :class="isOperationStageEdited ? 'border-warning' : ''">
          <b-card-title class="p-1 m-0 mt-2 text-center ">{{ $t("roadmap.stage.bgys-operation") }}</b-card-title>
          <content-loading v-if="isOperationLoading" />
          <b-card-body v-else class="p-2 m-0 ">
            <textarea class="form-control" placeholder="Aşama Açıklaması" v-model="descriptionOperation"> </textarea>
            <h5>{{ $t("task.plural") }}</h5>
            <div v-for="task in tasksOperation" :key="task._id" class="card card-body">
              <sweet-button :only-icon="true" variant="false" icon="mdi mdi-delete" buttonClass="text-danger hidden float-right" @click="removeTaskItem(task)" />
              <sweet-button :only-icon="true" variant="false" icon="mdi mdi-pencil" buttonClass="text-warning hidden float-right" @click="editTaskItem(task)" />

              <h6>{{ $t("task.name") }}</h6>
              {{ task.name | translate }}
              <h6>{{ $t("task.description") }}</h6>
              {{ task.description | translate }}

              <div v-if="task.blockedByTasks && task.blockedByTasks.length > 0">
                <h6>{{ $t("task.blocked-by") }}</h6>
                <ol>
                  <li v-for="t in task.blockedByTasks" :key="t._id">{{ t.name | translate }}</li>
                </ol>
              </div>
            </div>

            <roadmap-stage-task-form store="managementBgysRoadmap" stage="BGYS_OPERATION" />
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!---->

    <!---->
    <b-row>
      <b-col md="7" offset-md="2">
        <b-card no-body class="border mb-1" :class="isPerformanceRatingStageEdited ? 'border-warning' : ''">
          <b-card-title class="p-1 m-0 mt-2 text-center ">{{ $t("roadmap.stage.bgys-performance-rating") }}</b-card-title>
          <content-loading v-if="isPerformanceRatingLoading" />
          <b-card-body v-else class="p-2 m-0 ">
            <textarea class="form-control" placeholder="Aşama Açıklaması" v-model="descriptionPerformanceRating"> </textarea>
            <h5>{{ $t("task.plural") }}</h5>
            <div v-for="task in tasksOperation" :key="task._id" class="card card-body">
              <sweet-button :only-icon="true" variant="false" icon="mdi mdi-delete" buttonClass="text-danger hidden float-right" @click="removeTaskItem(task)" />
              <sweet-button :only-icon="true" variant="false" icon="mdi mdi-pencil" buttonClass="text-warning hidden float-right" @click="editTaskItem(task)" />

              <h6>{{ $t("task.name") }}</h6>
              {{ task.name | translate }}
              <h6>{{ $t("task.description") }}</h6>
              {{ task.description | translate }}

              <div v-if="task.blockedByTasks && task.blockedByTasks.length > 0">
                <h6>{{ $t("task.blocked-by") }}</h6>
                <ol>
                  <li v-for="t in task.blockedByTasks" :key="t._id">{{ t.name | translate }}</li>
                </ol>
              </div>
            </div>

            <roadmap-stage-task-form store="managementBgysRoadmap" stage="BGYS_PERFORMANCE_RATING" />
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <!---->
    <!---->
    <b-row>
      <b-col md="7" offset-md="2">
        <b-card no-body class="border mb-1" :class="isImprovementStageEdited ? 'border-warning' : ''">
          <b-card-title class="p-1 m-0 mt-2 text-center ">{{ $t("roadmap.stage.bgys-improvement") }}</b-card-title>
          <content-loading v-if="isImprovementLoading" />
          <b-card-body v-else class="p-2 m-0 ">
            <textarea class="form-control" placeholder="Aşama Açıklaması" v-model="descriptionImprovement"> </textarea>
            <h5>{{ $t("task.plural") }}</h5>
            <div v-for="task in tasksOperation" :key="task._id" class="card card-body">
              <sweet-button :only-icon="true" variant="false" icon="mdi mdi-delete" buttonClass="text-danger hidden float-right" @click="removeTaskItem(task)" />
              <sweet-button :only-icon="true" variant="false" icon="mdi mdi-pencil" buttonClass="text-warning hidden float-right" @click="editTaskItem(task)" />

              <h6>{{ $t("task.name") }}</h6>
              {{ task.name | translate }}
              <h6>{{ $t("task.description") }}</h6>
              {{ task.description | translate }}

              <div v-if="task.blockedByTasks && task.blockedByTasks.length > 0">
                <h6>{{ $t("task.blocked-by") }}</h6>
                <ol>
                  <li v-for="t in task.blockedByTasks" :key="t._id">{{ t.name | translate }}</li>
                </ol>
              </div>
            </div>

            <roadmap-stage-task-form store="managementBgysRoadmap" stage="BGYS_IMPROVEMENT" />
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <!---->

    <hr />
    <sweet-button @click="save()" type="submit" :loading="isUpdating" :disabled="isUpdating" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
      {{ $t("common.save") }}
    </sweet-button>
  </div>
</template>

<script>
import RoadmapStageTaskForm from "./component/roadmap-stage-task-form";
const state = "managementBgysRoadmap";

export default {
  components: { RoadmapStageTaskForm },
  data() {
    return {};
  },

  computed: {
    descriptionOrganizationContext: {
      get() {
        return this.$store.getters[`${state}/descriptionOrganizationContext`];
      },
      set(v) {
        this.$store.commit(`${state}/descriptionOrganizationContext`, v);
      },
    },
    descriptionLeadership: {
      get() {
        return this.$store.getters[`${state}/descriptionLeadership`];
      },
      set(v) {
        this.$store.commit(`${state}/descriptionLeadership`, v);
      },
    },
    descriptionPlanning: {
      get() {
        return this.$store.getters[`${state}/descriptionPlanning`];
      },
      set(v) {
        this.$store.commit(`${state}/descriptionPlanning`, v);
      },
    },
    descriptionSupport: {
      get() {
        return this.$store.getters[`${state}/descriptionSupport`];
      },
      set(v) {
        this.$store.commit(`${state}/descriptionSupport`, v);
      },
    },
    descriptionOperation: {
      get() {
        return this.$store.getters[`${state}/descriptionOperation`];
      },
      set(v) {
        this.$store.commit(`${state}/descriptionOperation`, v);
      },
    },
    descriptionPerformanceRating: {
      get() {
        return this.$store.getters[`${state}/descriptionPerformanceRating`];
      },
      set(v) {
        this.$store.commit(`${state}/descriptionPerformanceRating`, v);
      },
    },
    descriptionImprovement: {
      get() {
        return this.$store.getters[`${state}/descriptionImprovement`];
      },
      set(v) {
        this.$store.commit(`${state}/descriptionImprovement`, v);
      },
    },

    //
    editedStages() {
      return this.$store.getters[`${state}/editedStages`];
    },
    isOrganizationContextStageEdited() {
      return this.editedStages.includes("BGYS_ORGANIZATION_CONTEXT");
    },
    isLeadershipStageEdited() {
      return this.editedStages.includes("BGYS_LEADERSHIP");
    },
    isPlanningStageEdited() {
      return this.editedStages.includes("BGYS_PLANNING");
    },
    isSupportStageEdited() {
      return this.editedStages.includes("BGYS_SUPPORT");
    },
    isOperationStageEdited() {
      return this.editedStages.includes("BGYS_OPERATION");
    },
    isPerformanceRatingStageEdited() {
      return this.editedStages.includes("BGYS_PERFORMANCE_RATING");
    },
    isImprovementStageEdited() {
      return this.editedStages.includes("BGYS_IMPROVEMENT");
    },
    //
    isOrganizationContextLoading() {
      return this.$store.getters[`${state}/isOrganizationContextLoading`];
    },
    isLeadershipLoading() {
      return this.$store.getters[`${state}/isLeadershipLoading`];
    },
    isPlanningLoading() {
      return this.$store.getters[`${state}/isPlanningLoading`];
    },
    isSupportLoading() {
      return this.$store.getters[`${state}/isSupportLoading`];
    },
    isOperationLoading() {
      return this.$store.getters[`${state}/isOperationLoading`];
    },
    isPerformanceRatingLoading() {
      return this.$store.getters[`${state}/isPerformanceRatingLoading`];
    },
    isImprovementLoading() {
      return this.$store.getters[`${state}/isImprovementLoading`];
    },

    //
    tasks() {
      return this.$store.getters[`${state}/tasks`];
    },
    tasksOrganizationContext() {
      return this.tasks.filter((i) => i.stage == "BGYS_ORGANIZATION_CONTEXT");
    },
    tasksLeadership() {
      return this.tasks.filter((i) => i.stage == "BGYS_LEADERSHIP");
    },
    tasksPlanning() {
      return this.tasks.filter((i) => i.stage == "BGYS_PLANNING");
    },
    tasksSupport() {
      return this.tasks.filter((i) => i.stage == "BGYS_SUPPORT");
    },
    tasksOperation() {
      return this.tasks.filter((i) => i.stage == "BGYS_OPERATION");
    },
    tasksPerformanceRating() {
      return this.tasks.filter((i) => i.stage == "BGYS_PERFORMANCE_RATING");
    },
    tasksImprovement() {
      return this.tasks.filter((i) => i.stage == "BGYS_IMPROVEMENT");
    },
    //
    isUpdating() {
      return this.$store.getters[`${state}/isUpdating`];
    },
  },
  mounted() {
    this.loadStages();
    window.addEventListener("beforeunload", this.beforeUnload);
  },
  beforeRouteLeave(to, from, next) {
    const answer = window.confirm("Do you really want to leave? you have unsaved changes!");
    if (answer) {
      next();
    } else {
      next(false);
    }
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.beforeUnload);
  },

  methods: {
    beforeUnload(e) {
      if (this.editedStages.length == 0) {
        return undefined;
      }

      (e || window.event).returnValue = this.reloadMessage;
      return this.reloadMessage;
    },

    loadStages() {
      return this.$store.dispatch(`${state}/loadStages`);
    },
    async save() {
      const ok = await this.confirm(this.$t(`alert.approve`));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`${state}/save`);
        this.loadStages();
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        console.error(error);
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    removeTaskItem(task) {
      this.$store.commit(`${state}/removeTaskItem`, { task });
    },
    editTaskItem(task) {
      this.$store.commit(`${state}/editedTask`, { ...task });

      this.$root.$emit("bv::toggle::collapse", `sidebar-create-task-` + task.stage);
    },
  },
};
</script>
